<template>
    <v-container>
        <div v-if="!parentLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">{{ isRoot ? "Create Item Root Group" : "Create Sub Item Group" }}</h4>
                    <p class="text-subtitle-1">Item Group Creation Form</p>
                    <v-divider/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <ItemGroupForm ref="form" v-model="form" :is-root="isRoot"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn block class="primary" @click="handleSave">
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn block depressed @click="handleCancel">
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>

                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-bind="alert" v-model="alert.value"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions'
import {mapActions, mapGetters} from 'vuex'
import ItemGroupForm from './../../components/warehouse/ItemGroupForm';
import PAlert from "./../../components/common/PAlert.vue";
import { v4 as uuid } from 'uuid';

export default {
    name: "ItemGroupCreateView",
    components: {
        ItemGroupForm,
        PAlert
    },
    data() {
        return {
            form : null,
            loading : false ,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure",
                callback: null
            },
            perm: permissions,
            parentID: null,
            parentLoading: false,
            idempotentKey: null
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        }),
        isRoot() {
            return !this.parentID;
        }
    },
    methods: {
        ...mapActions({
            create: "stock/itemGroup/create",
            findByID: "stock/itemGroup/findByID",
            pushItemGroup: "stock/itemGroup/search/push",
            snackbar: "ui/snackbar/show"
        }),
        handleSave() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Save?", callback: this.save};
        },
        save() {
            if(!this.$refs.form.validate()) return ;
            this.loading = true
            this.create({...this.form, idempotentKey: this.idempotentKey}).then(response => {
                this.snackbar({ color: "success", text: "item Group Created" })

                // if a root group greated then navigate to the group display
                // but if a sub group is created then navigate to the parent group display
                this.$router.replace({ name: "ItemGroupDisplay", params: {id: this.isRoot ? response.data.id : this.form.parent_id}})


            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.loading = false;
            })
        },
        findByIDAsync() {
            this.parentLoading = true
            this.findByID(this.parentID).then(response => {
                this.form = {}
                this.form.parent_id = response.data.id
                this.pushItemGroup(response.data)
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.parentLoading = false;
            })
        },
        handleCancel() {
            this.$router.back();
        }
    },
    created() {
        this.parentID = this.$route.query.parent_id;
        if(this.parentID) this.findByIDAsync();
        this.idempotentKey = uuid();
    }
}
</script>

<style>

</style>